// import "../App.css";
import React, { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

// import "../Assets/Css/demoDashboard.css";
import JitsiComponent from "../../Component/JitsiComponent";

function JitSiConference() {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    roomName,
    domainName,
    token,
    liveId,
    classScheduleId,
    status,
    liveType,
    isFree,
    lectureType,
    fromDate,
    sessionTime,
    teacherName,
  } = location?.state;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onClickCallEnd = () => {
    const data = {
      liveId: liveId,
      status: status,
      fromDate: fromDate,
      sessionTime: sessionTime,
    };
    if (lectureType === "paid") {
      data["liveType"] = liveType;
    }
    navigate("/TeacherPanel/dashboard", {
      state: { postData: data, isFree, pageName: "JitSiConference" },
    });
  };

  const onClickCallLeave = () => {
    navigate("/TeacherPanel/dashboard");
  };

  return (
    <div
      style={{
        height: "calc(100vh - 0px)",
        padding: "10px",
      }}
    >
      <JitsiComponent
        domain={domainName}
        roomName={roomName}
        displayName={teacherName}
        token={token}
        onCallEnd={onClickCallEnd}
        onCallLeave={onClickCallLeave}
        classScheduleId={classScheduleId}
      />
    </div>
  );
}

export default JitSiConference;
